
import React from 'react';
import { Link } from 'react-router-dom';
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { UserPlus } from 'lucide-react';
import { Journalist } from "@/components/reader-home/types";

interface SuggestedJournalistItemProps {
  journalist: Journalist;
  onFollowJournalist: (journalistId: string) => void;
}

const SuggestedJournalistItem = ({ journalist, onFollowJournalist }: SuggestedJournalistItemProps) => {
  return (
    <div className="flex items-center justify-between p-2 rounded-lg hover:bg-accent">
      <Link 
        to={`/journalist/${journalist.id}`} 
        className="flex items-center flex-grow"
      >
        <Avatar className="h-10 w-10">
          <AvatarImage src={journalist.avatar} alt={journalist.name} />
          <AvatarFallback>{journalist.name ? journalist.name.substring(0, 2) : 'JN'}</AvatarFallback>
        </Avatar>
        <div className="ml-3">
          <p className="text-sm font-medium">{journalist.name}</p>
        </div>
      </Link>
      <Button 
        variant="ghost" 
        size="icon"
        onClick={(e) => {
          e.preventDefault(); // Prevent navigation when clicking the button
          onFollowJournalist(journalist.id);
        }}
        title={`Follow ${journalist.name}`}
      >
        <UserPlus className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default SuggestedJournalistItem;
